module.exports = __webpack_public_path__ + "media/img/vca/sponsors/feast-15b7d273535ebee171d961dabba73c4c.png";